<template>
  <a 
    @click.prevent="$emit('show-detail', provider)" 
    class="provider-card">
    <div class="card no-border" style="margin-bottom: 1rem">
      <div class="card-section no-padding">
        <div class="grid-x grid-padding-x align-middle">
          <div 
            class="cell small-5">
            <img 
              v-if="provider.image_url" 
              :src="provider.image_url"
              class="square rounded" />
          </div>
          <div 
            class="cell small-7">
            <div class="profile">
              <div style="padding: .5rem">
                <h6>{{ provider.formatted_name }}</h6>
                <p v-if="provider.specialties" class="no-margin">
                  {{ provider.specialties[0].title }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  name: 'ProviderCard',
  props: {
    provider: {
      type: Object,
      required: true
    }
  }
}
</script>
